import type {Code} from 'mdast'

import {containsRange} from '../syntax-tree/node-range-utils'
import {isPositionedNode} from '../syntax-tree/positioned-node'

function isOpenCodeBlock(node: Code) {
  return (
    node.children?.filter(child => child.type === 'delimiter' && child.tokenType === 'codeFencedFence').length === 1
  )
}

/** Checks if the given position is fully inside the code block (not outside or at the ends). */
export function isInsideCodeBlock(node: Code, position: number) {
  return (
    isPositionedNode(node) &&
    containsRange(position, position, node.position.start.offset, node.position.end.offset) &&
    node.position.start.offset !== position &&
    (isOpenCodeBlock(node) || node.position.end.offset !== position)
  )
}
